import { render } from "./Customers.vue?vue&type=template&id=41756e67&ts=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__